import { Injectable } from '@angular/core';
import { PaginationState, PaginationStateService, UTCDateString } from 'ats-ui-lib';
import { HiringRegimeTypeEnum } from '@models/index';
import { JobOpportunityService } from '../job-opportunity/job-opportunity.service';

const pageSize = 9;

export interface JobOpportunityListState extends PaginationState<JobOpportunityListItem> {}

const initialState: JobOpportunityListState = {
  page: [],
  pageNumber: 1,
  isLoading: false,
  pageSize: pageSize,
  hasNext: false,
  order: [{ field: 'dateTimePublication', asc: false }],
  isEmpty: true,
  initialized: false,
  isLoadingNextPage: false,
};

@Injectable({ providedIn: 'root' })
export class JobOpportunityListStateService extends PaginationStateService<
  JobOpportunityListItem,
  JobOpportunityListState
> {
  constructor(private jobOpportunityService: JobOpportunityService) {
    super(initialState, jobOpportunityService, pageSize);
  }
}

export enum JobApplicationTypeEnum {
  Traditional = 1,
  Simplified = 2,
}

export interface JobOpportunityListItem {
  id: string;
  tenantId: string;
  title: string;
  cityName: string | null;
  stateSmallName: string | null;
  dateTimePublication: UTCDateString;
  isHomeOffice: boolean;
  isHybrid: boolean;
  isLocal: boolean;
  code: number;
  divulgationName: string;
  subdomain: string;
  hiringRegime: HiringRegimeTypeEnum[];
  salaryRangeMinimum: number | null;
  salaryRangeMaximum: number | null;
  companyIconDescription: string | null;
  companyIconId: string | null;
  pageUrl: string | null;
  jobApplicationType: JobApplicationTypeEnum;
  isWhatsAppJobApplicationEnabled: boolean;
  whatsAppLink: string | null;
}
